import { PlanLabel } from '../types'
import { useMemo } from 'react'
import { useScreenSizeBreakpoints } from '@app/common/src/hooks/useScreenSizeBreakpoints'

const GRAPHICS_PLANS_INDECES = [
  PlanLabel.PRO,
  PlanLabel.PRO_PLUS,
  PlanLabel.ENTERPRISE,
  PlanLabel.COMPARE,
  PlanLabel.NEXT_PLAN
]

export const useTileGraphicsByScreenSize = (): { [key in PlanLabel]: string } => {
  const { isLargeDesktop, isTablet, isMobile, isXSMobile } = useScreenSizeBreakpoints()
  const screenSize = useMemo(() => {
    if (isXSMobile) return 'xs'
    if (isMobile) return 'sm'
    if (isTablet) return 'md'
    if (isLargeDesktop) return 'xl'
    return 'lg'
  }, [isLargeDesktop, isTablet, isMobile, isXSMobile])
  const tileGraphicsByScreenSize: { [key in PlanLabel]: string } = useMemo(
    () =>
      GRAPHICS_PLANS_INDECES.reduce((acc, plan) => {
        return { ...acc, [plan]: getTileGraphicForPlan(plan, screenSize) }
      }, {} as { [key in PlanLabel]: string }),
    [screenSize]
  )
  return tileGraphicsByScreenSize
}

const PLANS_UPGRADE_GRAPHIC_BASE_PATH = '/graphics/plansUpgradeDialog/'

export const getTileGraphicForPlan = (planLabel: PlanLabel | undefined, size: string): string => {
  const basePath = `${PLANS_UPGRADE_GRAPHIC_BASE_PATH}${size}/`
  switch (planLabel) {
    case PlanLabel.PRO:
      return `${basePath}pro.png`
    case PlanLabel.PRO_PLUS:
      return `${basePath}proplus.png`
    case PlanLabel.ENTERPRISE:
      return `${basePath}enterprise.png`
    case PlanLabel.NEXT_PLAN:
      return `${basePath}nextPlanImage.jpeg`
    case PlanLabel.COMPARE:
    default: //compare plans
      return `${basePath}compare.png`
  }
}
